var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('p',[_vm._v(_vm._s(_vm.cookie.name))]),_c('ul',{staticClass:"c-category-item-cookie"},_vm._l((["description", "generator"]),function(id){return _c('li',{key:id},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.text(id))}})])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }